// src/components/Footer/Footer.jsx
import React from 'react';
import '../../../assests/css/customer/Footer.css';

const Footer = () => {
  return (
    <footer className="CustomerSide-Footer-footer">
      <div className="CustomerSide-Footer-footer-container">

        {/* Contact */}
        <div className="CustomerSide-Footer-footer-column">
          <h3 className="CustomerSide-Footer-footer-heading">Contact</h3>
          <ul className="CustomerSide-Footer-footer-links">
            <li><a href="tel:01234567890" className="CustomerSide-Footer-footer-link">01234 567 890</a></li>
            <li><a href="mailto:info@lorem-ipsum.co.uk" className="CustomerSide-Footer-footer-link">Moonlit@gmail.com</a></li>
          </ul>
        </div>

        {/* Shop */}
        <div className="CustomerSide-Footer-footer-column">
          <h3 className="CustomerSide-Footer-footer-heading">Shop</h3>
          <ul className="CustomerSide-Footer-footer-links">
            <li><a href="/products/Women" className="CustomerSide-Footer-footer-link">Women</a></li>
            <li><a href="/products/Men" className="CustomerSide-Footer-footer-link">Men</a></li>
            <li><a href="/products/Kids" className="CustomerSide-Footer-footer-link">Kids</a></li>
            <li><a href="/products/Accessories" className="CustomerSide-Footer-footer-link">Accessories</a></li>
            <li><a href="/about-us" className="CustomerSide-Footer-footer-link">About</a></li>
            <li><a href="/blog" className="CustomerSide-Footer-footer-link">Blog</a></li>
            <li><a href="/contact-us" className="CustomerSide-Footer-footer-link">Contact</a></li>
          </ul>
        </div>

        {/* Company */}
        <div className="CustomerSide-Footer-footer-column">
          <h3 className="CustomerSide-Footer-footer-heading">Company</h3>
          <ul className="CustomerSide-Footer-footer-links">
            <li><a href="/cookies" className="CustomerSide-Footer-footer-link">Cookies</a></li>
            <li><a href="/payments" className="CustomerSide-Footer-footer-link">Payments</a></li>
            <li><a href="/terms" className="CustomerSide-Footer-footer-link">Terms & Conditions</a></li>
            <li><a href="/privacy" className="CustomerSide-Footer-footer-link">Privacy Policy</a></li>
            <li><a href="/security" className="CustomerSide-Footer-footer-link">Security</a></li>
          </ul>
        </div>

      </div>

      {/* Bottom Section */}
      <div className="CustomerSide-Footer-footer-bottom">
        <div className="CustomerSide-Footer-footer-container copyright-center">
          <p>&copy; {new Date().getFullYear()} MOONLIT. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;